// extracted by mini-css-extract-plugin
export default {"grid":"ForgotPassword_grid__60er1","section":"ForgotPassword_section__wmHZ2","content":"ForgotPassword_content__dmkmd","account":"ForgotPassword_account__-N+KC"};